import postWithToken from './base/post-with-token'

const customerSendEmail = (id, data) => postWithToken(`/customer/${id}/email`)(data)

export default customerSendEmail
